import { render, staticRenderFns } from "./DifferenceTable.vue?vue&type=template&id=e36ac5e0"
import script from "./DifferenceTable.vue?vue&type=script&lang=js"
export * from "./DifferenceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports